import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { BackArrowIcon } from '../../../components/icons';
import SidebarNavigation from '../../SidebarNavigation/component';
import TopNavigation from '../../TopNavigation/container';
import RecentEsimOrdersList from '../_components/RecentEsimOrdersList/RecentEsimOrdersList';
import './styles.scss';

function RecentlyOrderedESimsComponent(props: any) {
  const history = useHistory();

  useEffect(() => {
    document.title = 'Recently Ordered SIMs | UltraIoT';
  }, []);

  return (
    <div className="layout-has-sidebar">
      <SidebarNavigation {...props} />
      <TopNavigation {...props} />

      <main className="dashboard-layout-content">
        <div className="row align-items-md-center mb-4">
          <div className="col-md-4">
            <button
              className="btn btn-back"
              onClick={() => history.push('/spr-dashboard')}
            >
              <BackArrowIcon className="back-icon" /> Back to SPR Dashboard
            </button>
          </div>

          <div className="col-md-8 text-right"></div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <RecentEsimOrdersList />
          </div>
        </div>
      </main>
    </div>
  );
}

export default RecentlyOrderedESimsComponent;
